

import React from "react";

export const ChevronDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-3.5 h-3.5 text-gray-100",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M11.1382 4.19526C11.3986 4.45561 11.3986 4.87772 11.1382 5.13807L7.13823 9.13807C6.87788 9.39842 6.45577 9.39842 6.19542 9.13807L2.19542 5.13807C1.93507 4.87772 1.93507 4.45561 2.19542 4.19526C2.45577 3.93491 2.87788 3.93491 3.13823 4.19526L6.66683 7.72386L10.1954 4.19526C10.4558 3.93491 10.8779 3.93491 11.1382 4.19526Z" fill="currentColor" />
        </svg>

    );
};